var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"ps-label ps-block ps-text-sm ps-font-medium ps-leading-5 ps-text-gray-700"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }